import React from 'react';
import { Link } from '@reach/router';
import styles from './side-panel-nav-button.module.scss';

interface Props {
  href: string;
}

export const SidePanelNavButton: React.FC<Props> = ({ children, href }) => (
  <Link to={href} className={styles.button}>
    {children}
  </Link>
);
